var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"playerContainer",staticClass:"player-container",style:({height: _vm.height})}),_vm._v(" "),(!_vm.id)?_c('div',{style:({height: _vm.height})},[_c('el-empty',{attrs:{"image-size":80,"description":"无视频接入"}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c20a5bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/video/BesoWebRTCVideo.vue
// module id = null
// module chunks = 